<script>
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();
    const SWITCH_EVENT = 'switch'

    let switchedOn = false;
    $: text = switchedOn ? 'light' : 'dark';

    function dispatchStateChange() {
        switchedOn = !switchedOn;
        dispatch(SWITCH_EVENT, switchedOn);
    }
</script>

<!--------------------------------------------------------------------------------------------------------------------->

<div class="wrapper" title="{text} mode">
    <label class="switch">
        <input type="checkbox" on:change={dispatchStateChange}>
        <span class="slider" class:slider-dark={switchedOn}></span>
    </label>
    <span class="text" class:text-left={text==='light'}>{text}</span>
</div>
<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .wrapper {
        position: relative;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 52px;
        height: 24px;
        margin: 0 3px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: white;
        border: 1px solid var(--dark-grey);
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 34px;
    }

    .slider-dark {
        background-color: #d2d2d8;
    }

    .slider:before {
        position: absolute;
        left: 1px;
        bottom: 1px;
        content: "";
        height: 20px;
        width: 20px;
        background-image: url("../resources/images/moon.jpeg") ;
        background-size: cover;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 50%;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(27px);
        -ms-transform: translateX(27px);
        transform: translateX(27px);
        background-image: url("../resources/images/sun.jpeg");
        outline: none;
    }

    /* ------------ */
    .text {
        position: absolute;
        font-size: .7rem;
        right: 8px;
        top: 4px;
    }

    .text-left {
        right: 28px;
        color: var(--white-color);
    }
</style>